module.exports = __webpack_public_path__ + "img/default_user.901d5ea6.png";